var { Sidechain } = require("@nprapps/sidechain");
Sidechain.registerGuest();

// build our custom D3 object
var d3 = {
  ...require("d3-scale/dist/d3-scale.min")
};

var { COLORS, classify } = require("./lib/helpers");
var { isMobile } = require("./lib/breakpoints");
var $ = require("./lib/qsa");

// Global vars

var percent = n => n ? n.toFixed(1) + "%" : "-";
var signed = n => (n >= 0 ? "+" : "") + n.toFixed(1);
var signedParens = n => n ? `(${signed(n)})` : ""

// Initialize the graphic.
var onWindowLoaded = function () {
  render();

  window.addEventListener("resize", render);
};

// Render the graphic(s).
var render = function () {
  var containers = document.querySelectorAll(".map-container");
  for (var element of containers) {
    // Render the map!
    var width = element.offsetWidth;
    renderStateGridMap({
      element,
      width,
      data: DATA,
      // isNumeric will style the legend as a numeric scale
      isNumeric: true,
    });
  }
};

// Render a state grid map.
var renderStateGridMap = function (config) {
  var { data, element } = config;
  var valueColumn = element.dataset.value;

  // Clear existing graphic (for redraw)
  element.innerHTML = "";

  // Copy map template
  var template = document.querySelector("#map-template");
  element.append(template.content.cloneNode(true));

  var values = data.map(d => d[valueColumn]);
  var min = Math.min(...values);
  if (Math.abs(min) < 1) min = 0;
  var max = Math.max(...values);

  // Extract categories from data
  var categories = [];

  // Create legend
  var legendWrapper = element.querySelector(".key-wrap");

  var outer = Math.max(Math.abs(min), Math.abs(max));

  var colorScale = d3
    .scaleLinear()
    .unknown("white")
    .domain(min < 0 ? [-outer, 0, outer] : [min, max])
    .range(min < 0 ? [COLORS.yellow2, COLORS.gray1, COLORS.teal3] : [COLORS.gray1, COLORS.peach2]);

  var stops = colorScale.range().join(", ");

  legendWrapper.innerHTML = `
  <div class="label">${signed(colorScale.domain()[0])}</div>
  <div class="bar" style="background: linear-gradient(to right, ${stops}"></div>
  <div class="label">${signed(colorScale.domain().at(-1))}</div>
  `

  // Select SVG element
  var chartElement = element.querySelector("svg");

  // Set state colors
  data.forEach(function (state) {
    var value = state[valueColumn];
    if (typeof value == "number") {
      var stateClass = "state-" + classify(state.state_name);
      var categoryClass = "category-" + classify(value + "");

      var selected = chartElement.querySelector("." + stateClass);
      selected.setAttribute("class", `${stateClass} ${categoryClass} state-active`);
      selected.setAttribute("fill", colorScale(value));
      selected.dataset.state = state.state_name;
    }
  });

  var ns = chartElement.namespaceURI;
  var labelGroup = document.createElementNS(ns, "g");
  chartElement.append(labelGroup);
  for (var d of config.data) {
    var state = STATES.find(s => s.name == d.state_name);
    var text = document.createElementNS(ns, "text");
    text.setAttribute("text-anchor", "middle");
    text.textContent = state.usps; //isMobile.matches ? state.usps : state.ap;
    labelGroup.append(text);
    if (typeof d[valueColumn] == "number") {
      text.setAttribute("class", `label label-active`);
    } else {
      text.setAttribute("class", "label");
    }
    var box = chartElement.querySelector(`.state-${classify(state.name)}`);
    var boxBounds = box.getBBox();
    var textBounds = text.getBBox();
    text.setAttribute("x", boxBounds.x + boxBounds.width * .5 + .6);
    text.setAttribute("y", boxBounds.y + boxBounds.width * .5 + textBounds.height * .5);
  }
};

// Initially load the graphic
// (NB: Use window.load to ensure all images have loaded)
window.onload = onWindowLoaded;

var container = document.querySelector(".graphic");
var tooltip = document.querySelector(".tooltip");

container.addEventListener("mousemove", function(e) {
  var state = e.target.dataset.state;
  if (!state) return tooltip.toggleAttribute("hidden", true);
  var data = window.DATA.find(d => d.state_name == state);
  var svg = e.target.closest("svg");
  var x = e.clientX;
  var y = e.clientY;
  var cBounds = container.getBoundingClientRect();
  x -= cBounds.left;
  y -= cBounds.top;
  tooltip.innerHTML = `
<h3>${data.state_name}</h3>

<ul>
  <li> 2018-19: <b>${percent(data.CAR_1819)}</b>
  <li> 2021-22: <b>${percent(data.CAR_2122)} ${signedParens(data.delta_18_21)}</b>
  <li> 2022-23: <b>${percent(data.CAR_2223)} ${signedParens(data.delta_21_22)}</b>
</ul>
  `;
  tooltip.toggleAttribute("hidden", false);
  if (x > window.innerWidth / 2) x -= tooltip.offsetWidth;
  y -= tooltip.offsetHeight;
  tooltip.style.left = x + "px";
  tooltip.style.top = y + "px";
});